import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { ScrollText } from "lucide-react";

const ACTION_LABEL = {
  login: "Login", login_google: "Login Google", register: "Registrazione", create: "Creazione",
  edit: "Modifica", delete: "Eliminazione", upload: "Upload", ai_query: "Query AI",
  ai_analysis: "Analisi AI", ai_feedback: "Feedback AI", review: "Review",
};

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)).catch(() => setErr(true)); }, []);

  return (
    <div className="ri-fade-in">
      <PageHeader overline="GxP-ready · Audit Trail immutabile" title="Audit Trail"
        subtitle="Registro immutabile di login, upload, modifiche, query e risultati AI, approvazioni e chiusure." />
      {err ? (
        <div className="rounded-xl bg-white border border-slate-200 p-8 text-center text-slate-400 text-sm">
          Accesso riservato agli amministratori dell'organizzazione.
        </div>
      ) : (
        <div className="rounded-xl bg-white border border-slate-200 overflow-x-auto">
          <table className="ri-table">
            <thead><tr><th>Timestamp</th><th>Utente</th><th>Azione</th><th>Oggetto</th><th>ID</th></tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} data-testid={`audit-row-${l.id}`}>
                  <td className="font-mono text-xs">{(l.timestamp || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="text-xs">{l.user_email || l.user_id}</td>
                  <td><span className="text-xs font-medium">{ACTION_LABEL[l.action] || l.action}</span></td>
                  <td className="text-xs text-slate-500">{l.object_type}</td>
                  <td className="font-mono text-[0.65rem] text-slate-400">{l.object_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
